<template lang="pug">
  .page-container
    Toolbar
    .app-breadcrumbs.center-breadcrumbs
      v-container.breadcrumbs-container.center-container
        img.breadcrumbs-logo(src="../../assets/logo.png")/
        v-breadcrumbs(:items="breadcrumbs")
          template(slot="item" slot-scope="props")
            router-link(
              :to="props.item.to"
              class="app-breadcrumbs__item"
            ) {{ props.item.text }}

    v-container
      table.product-table
        thead
          tr
            th {{ $t("shoppingCart.productId") }}
            th {{ $t("shoppingCart.productImg") }}
            th {{ $t("shoppingCart.productName") }}
            th {{ $t("shoppingCart.unitPrice") }}
            th {{ $t("shoppingCart.quantity") }}
            th {{ $t("shoppingCart.unit") }}
            th {{ $t("shoppingCart.subtotal") }}
            th
        tbody
          tr(v-for='(item, index) in shoppingCart.list')
            td {{item.spuId}}
            td
              .product-img
                img(:src='item.cover')/
            td
              .name {{item.spuName}}
              .spec {{item.specInfo}}
            td.unit-price {{item.price}}
            td
              v-btn(fab small flat color='primary' @click="handleEditCart(item, -1)" :loading='minsLoading && (checkedSkuId == item.skuId)')
                v-icon remove
              span {{item.num}}
              v-btn(fab small flat color='primary' @click="handleEditCart(item, 1)" :loading='plusLoading && (checkedSkuId == item.skuId)')
                v-icon add
            td {{item.unit}}
            td.price {{item.totalPrice}}
            td
              v-btn(fab small flat @click="handleDeleteCart(item)")
                v-icon close

      v-layout.address-container
        v-flex
          .address-list
            AddressList(
              is-selection
              v-model="addressGuid"
              create-success-redirect-type="back"
              edit-success-redirect-type="back"
            )
        v-flex
          .total-container
            div.total-price {{ $t("shoppingCart.total") }}
              span {{shoppingCart.totalAmount}} {{ $t("shoppingCart.eur") }}

      .btn-container
        v-btn(color="#90d3a6" dark round large @click="$router.push({ name: 'shop' })") {{ $t("shoppingCart.keepBuying") }}
        v-btn(color="#75d1d7" dark round large v-if='shoppingCart.list.length != 0' @click.stop="dialog = true") {{ $t("shoppingCart.confirmOrder") }}


    v-dialog(
      v-model="dialog"
      max-width="290"
    )
      v-card
        v-card-title.headline {{ $t("shoppingCart.whetherToConfirmTheOrder") }}
        v-card-actions
          v-btn(
            color="green darken-1"
            flat="flat"
            @click="dialog = false"
          ) {{ $t("shoppingCart.cancel") }}

          v-btn(
            color="green darken-1"
            flat="flat"
            @click="submit"
          ) {{ $t("shoppingCart.confirm") }}

</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Toolbar from "../../components/common/toolbar";
import AddressList from "../../components/common/address-list";
import order from "../../api/order.js";
import account from "../../api/account.js";

export default {
  data() {
    return {
      addressGuid: null,
      plusLoading: false,
      minsLoading: false,
      checkedSkuId: null,
      dialog: false
    };
  },
  mounted() {
    this.loadShoppingCart();
    this.loadDefaultAddress();
  },
  computed: {
    ...mapState(["shoppingCart", "addressId"]),

    breadcrumbs() {
      return [
        {
          to: { name: "home" },
          disabled: false,
          text: this.$t("nav.home")
        },
        {
          to: { name: "shopping-cart" },
          disabled: false,
          text: this.$t("nav.shoppingCart")
        }
      ];
    }
  },
  components: {
    Toolbar,
    AddressList
  },
  methods: {
    ...mapActions(["loadShoppingCart"]),
    ...mapMutations(["setAddressId"]),

    async handleEditCart(skus, num) {
      this.checkedSkuId = skus.skuId;
      const payload = {
        skuId: skus.skuId,
        num
      };
      if (num == 1) {
        this.plusLoading = true;
      } else {
        this.minsLoading = true;
      }
      try {
        const res = await order.addCart(payload);
        if (res.data.status == "fail") {
          this.$toasted.show(res.data.msg);
        } else if (res.data.status == "SUCCESSS") {
          await this.loadShoppingCart();
        }

        this.plusLoading = false;
        this.minsLoading = false;
      } catch (e) {
        console.log(e);
      }
    },

    async submit() {
      this.dialog = false;

      let carts = this.shoppingCart.list.flatMap(item => item.cartId);

      try {
        const res = await order.createOrder({
          addressId: this.addressId,
          carts: "[" + carts + "]"
        });
        if (res.data.status == "fail") {
          this.$toasted.show(res.data.msg);
        } else if (res.data.status == "SUCCESSS") {
          console.log(res.data);
          this.$toasted.success(this.$t("shoppingCart.orderSuccess"));
          setTimeout(() => {
            this.$router.push({ name: "order-list" });
          }, 500);
        }
      } catch (e) {
        console.log(e);
      }
    },

    async loadDefaultAddress() {
      try {
        const res = await account.getDefaultAddress();
        if (res.data.status == "fail") {
          this.$toasted.show(res.data.msg);
        } else if (res.data.status == "SUCCESSS") {
          this.addressGuid = res.data.data.addressId;
          this.setAddressId(res.data.data.addressId);
        }
      } catch (e) {
        console.log(e);
      }
    },

    async handleDeleteCart(cart) {
      let cartList = this.shoppingCart.list;
      let deleteIndex = "";
      let data = [];
      this.shoppingCart.list.map((item, index) => {
        if (item.cartId == cart.cartId) {
          deleteIndex = index;
        }
      });
      cartList.splice(deleteIndex, 1);
      cartList.map((item, index) => {
        data[index] = {
          cart_id: item.cartId,
          num: item.num
        };
      });

      try {
        const res = await order.deleteCart({ data: JSON.stringify(data) });
        if (res.data.status == "fail") {
          this.$toasted.show(res.data.msg);
        } else if (res.data.status == "SUCCESSS") {
          console.log("");
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style scoped lang="sass" src="./shopping-cart.sass"></style>
